const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
]

const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

export function formatRelativeTime(iso: string, now: Date = new Date()): string {
  let duration = (new Date(iso).getTime() - now.getTime()) / 1000
  for (const { amount, unit } of DIVISIONS) {
    const rounded = Math.round(duration)
    if (Math.abs(rounded) < amount) {
      return formatter.format(rounded, unit)
    }
    duration /= amount
  }
  return formatter.format(Math.round(duration), 'year')
}

const COMPACT_UNITS: { seconds: number; suffix: string; unit: Intl.RelativeTimeFormatUnit }[] = [
  { seconds: 7 * 86400, suffix: 'w', unit: 'week' },
  { seconds: 86400, suffix: 'd', unit: 'day' },
  { seconds: 3600, suffix: 'h', unit: 'hour' },
  { seconds: 60, suffix: 'm', unit: 'minute' },
]

const spokenFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'always' })

export function formatCompactRelativeTime(
  iso: string,
  now: Date = new Date(),
): { short: string; spoken: string } {
  const then = new Date(iso)
  const months = wholeMonthsBetween(then, now)
  if (months >= 12) return compactTime(Math.floor(months / 12), 'y', 'year')
  if (months >= 1) return compactTime(months, 'mo', 'month')
  const elapsed = Math.max(0, (now.getTime() - then.getTime()) / 1000)
  const match = COMPACT_UNITS.find(({ seconds }) => elapsed >= seconds)
  if (!match) return { short: 'now', spoken: 'just now' }
  return compactTime(Math.floor(elapsed / match.seconds), match.suffix, match.unit)
}

function compactTime(value: number, suffix: string, unit: Intl.RelativeTimeFormatUnit) {
  return { short: `${value}${suffix}`, spoken: spokenFormatter.format(-value, unit) }
}

function wholeMonthsBetween(from: Date, to: Date): number {
  const months = (to.getUTCFullYear() - from.getUTCFullYear()) * 12 + to.getUTCMonth() - from.getUTCMonth()
  return timeIntoMonth(to) < timeIntoMonth(from) ? months - 1 : months
}

function timeIntoMonth(date: Date): number {
  return date.getTime() - Date.UTC(date.getUTCFullYear(), date.getUTCMonth())
}
